
























































































import { Component, Vue } from "vue-property-decorator";
import { Button, CellGroup, Dialog, Field, Icon, Loading } from "vant";
import { isEmail } from "@/utils/verify";
import { pageBusProviderShut } from "@/utils/hybirdMethods";
import navButtons from "@/views/app-pages/components/navButtons.vue";
@Component({
  name: "EmailBind",
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    navButtons
  }
})
export default class EmailBind extends Vue {
  email = "";
  captcha = "";
  img = "";
  key = "";
  showSuccessDialog = false;
  isCaptchaLoading = false;
  isCaptchaError = false;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isSubmitDisabled() {
    return !(this.email && this.captcha);
  }

  activated() {
    const userInfo = (this as any).$localstorage.get("userInfo") || {};
    this.email = userInfo.email;
    this.img = "";
    this.key = "";
    this.captcha = "";
    this.handleGetCaptcha();
  }

  handleGetCaptcha() {
    this.isCaptchaLoading = true;
    (this as any).$apis
      .getCaptcha()
      .then(res => {
        
        this.isCaptchaLoading = false;
        const { img, key } = res;
        this.img = img;
        this.key = key;
      })
      .catch(e => {
        this.isCaptchaLoading = false;
        this.isCaptchaError = true;
        
      });
  }

  handleBindEmail() {
    if (!isEmail(this.email))
      return this.$toast.fail(this.$t("common.email_verify_fail_text"));
    const { type } = this.$route.query;
    (this as any).$apis
      .bindEmail({
        key: this.key,
        email: this.email,
        captcha: this.captcha,
        type: type ? 1 : 2
      })
      .then(res => {
        // 有msg则证明code不为0
        if ( res.msg ) {
          return false
        }
        let userInfo = (this as any).$localstorage.get("userInfo") || {};
        userInfo = {
          ...userInfo,
          email: this.email
        };
        
        (this as any).$localstorage.set("userInfo", userInfo);
        this.showSuccessDialog = true;
        // this.$localstorage;
      })
      .catch(e => {
        
      });
  }

  handleConfirmEmailBind() {
    const { type } = this.$route.query;
    if (type === "1") {
      pageBusProviderShut({
        bus_code: "USER_INFO_EMAIL_MODIFY",
        parameter: {
          email: this.email
        }
      });
    } else {
      this.$router.go(-1);
    }
  }
}
